import { Formik, Form } from 'formik';

import { FormActions } from '@@/form-components/FormActions';

import { KubernetesSecurityFormData } from './security.types';
import { KubernetesSecurityInnerForm } from './KubernetesSecurityInnerForm';

interface Props {
  initialValues: KubernetesSecurityFormData;
  onSubmit: (values: KubernetesSecurityFormData) => void | Promise<void>;
  /** Mode: 'create' | 'edit' */
  mode: 'create' | 'edit';
  /** Whether the policy name has been provided (for validation) */
  nameProvided: boolean;
  /** Whether the environment groups have been provided (for validation) */
  environmentGroupsProvided: boolean;
}

/**
 * Kubernetes Security Policy Form Component
 *
 * Renders the security constraints form for Kubernetes policies.
 * Can be used for both creating new policies and editing existing ones.
 */
export function KubernetesSecurityPolicyForm({
  initialValues,
  onSubmit,
  mode,
  nameProvided,
  environmentGroupsProvided,
}: Props) {
  return (
    <Formik<KubernetesSecurityFormData>
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnMount
    >
      {({ values, setFieldValue, isValid, isSubmitting }) => (
        <Form>
          <KubernetesSecurityInnerForm
            formData={values}
            onChange={(key, value) => setFieldValue(key, value)}
          />

          <FormActions
            submitLabel={mode === 'create' ? 'Create policy' : 'Update policy'}
            loadingText={mode === 'create' ? 'Creating...' : 'Updating...'}
            isLoading={isSubmitting}
            isValid={isValid && !!nameProvided && !!environmentGroupsProvided}
            data-cy="policy-form-actions"
          />
        </Form>
      )}
    </Formik>
  );
}
